import React, {
    useState,
    useEffect,
  } from 'react'
  
  import { 
    Col, 
    Row,
    Table,
  } from 'antd';
  
  import { useNavigate } from "react-router-dom" 
  
  
  const CorporateMemberTab = ({memberData}) => {
    const navigate = useNavigate() 
    const [corporateMember, setCorporateMember] = useState(false);
    const [filterConfig, setFilterConfig] = useState({
      member_id: '',
      term: '',
    })
    
    const columns = [
      {
          title: 'Member ID',
          dataIndex: 'member_no',
          key: 'member_no',
          width:'15%',
          sorter: (a, b) => a.member_no?.localeCompare(b.member_no),
      },
      {
          title: 'Member Name',
          dataIndex: 'member_name',
          key: 'member_name',
          width:'35%',
          sorter: (a, b) => a.member_name?.localeCompare(b.member_name),
      
      },
      {
          title: 'Cust ID',
          dataIndex: 'ar_cust_id',
          key: 'ar_cust_id',
          width:'35%',
          sorter: (a, b) => a.ar_cust_id?.localeCompare(b.ar_cust_id),
      
      },
    ];
    const handleTableChange = (pagination) => {
      setFilterConfig((prev) => ({
        ...prev,
        page: parseInt(pagination.current),
        page_size: pagination.pageSize
      }));
    };
    useEffect(() => {
        if(memberData){
            setCorporateMember(memberData?.members)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [memberData]);
  
    return (
      <Row className='tab-container custom-padding'>
        <Col span={24}>
          <Table 
            columns={columns} 
            dataSource={corporateMember} 
            // loading={{
            //   indicator: customSpinner,
            //   spinning: isLoading,
            // }}
            pagination={{
            defaultPageSize: 10,
            //   total: pageSize,
            current: filterConfig?.page,
            pageSize: filterConfig?.total_records_per_page,
            }}
            onChange={handleTableChange}
            onRow={(record) => {
                return {
                  className: 'cursor',
                  onClick: () => navigate('/member/profile/',{ state: { id: record.id } }),
                };
            }}
          />
        </Col>
      </Row>
    )
  }
  export default CorporateMemberTab
  